import { Remittance,RemittanceRepository  } from '../domain/Remittance'

export class RemittanceListComponent {

    remittance_repo: RemittanceRepository
    remittances: Remittance[]
    loading: boolean
    totalItems: number
    selectedItems: Array<Object>
    company_id:number
    remittance_headers: Array<Object>
    limit: number
    offset: number
    selected_remittance: Remittance
    snackbar: Object;
    unremit_dialog: boolean
    mark_as_paid_dialog: boolean
    showSelect: boolean = false
    loadingDelete: boolean = false
    deleteDialog: boolean = false


    constructor(remittance_repo) {
        this.remittance_repo = remittance_repo
        this.remittances = []
        this.loading = false
        this.totalItems = 0
        this.selectedItems = []
        this.company_id = 0
        this.remittance_headers = [
            { text: 'ID', value: 'uuid' },
            { text: 'Estado', value: 'state' },
            { text: 'Fecha', value: 'date' },
            { text: 'Facturas remesadas', value: 'invoices_count' },
            { text: 'Total', value: 'totalAmount' },
            {
                text: '',
                align: 'end',
                sortable: false,
                value: 'actions',
            },
        ]
        this.limit = 10
        this.offset = 0
        this.snackbar = {
            isVisible: false,
            text: '',
            color: '',
            timeout: 3000,
          }
        this.unremit_dialog = false
        this.mark_as_paid_dialog = false
        this.showSelect = false
        this.loadingDelete = false
        this.deleteDialog = false
    }

    success_message(message: string){
        this.snackbar['text'] = message
        this.snackbar['color'] = 'success'
        this.snackbar['isVisible'] = true
    }

    error_message(message: string){
        this.snackbar['text'] = message
        this.snackbar['color'] = 'error'
        this.snackbar['isVisible'] = true
    }

    async updateRemittanceList(company_id: number, filters:any) {
        this.loading = true
        this.company_id = company_id
        let res = await this.remittance_repo.get_remitances(parseInt(company_id.toString()))
        this.remittances = res['results']
        this.totalItems = res['count']
        this.showSelect = this.remittances.length > 0
        this.loading = false

    }

    downloadRemittance(uuid) {
        let xmlString = this.remittances.find(remittance => remittance.uuid == uuid).xml
        const blob = new Blob([xmlString], { type: 'application/xml' });

        // Create a download link
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'remesa_'+uuid+'.xml';
        link.click();

        // Clean up the URL object
        URL.revokeObjectURL(link.href);
    }

    async unremit_selected() {
        let res = await this.remittance_repo.unremit_remittance(this.selected_remittance.uuid)
        this.selected_remittance = null
        this.unremit_dialog = false
        console.log(res)
        if (res['ok']) {
            this.success_message(res['ok'])
        }
        else {
            this.error_message(res['error'])
        }
    }
    async mark_as_paid_selected() {
        let res = await this.remittance_repo.mark_as_paid_remittance(this.selected_remittance.uuid)
        this.selected_remittance = null
        this.mark_as_paid_dialog = false
        if (res['ok']) {
            this.success_message(res['ok'])
        }
        else {
            this.error_message(res['error'])
        }
    }

    previewDeleteDialog() {
        if (this.selectedItems.length == 0) {
            this.error_message("Debe seleccionar al menos una remesa")
            return
        }
        else if (this.selectedItems.some((item) => item['state'] == 'paid')) {
            this.error_message("No se pueden eliminar remesas pagadas")
            return
        } else {
            this.deleteDialog = true
        }
    }

    async deleteRemittances() {
        this.loadingDelete = true
        this.deleteDialog = false
        let remittance_ids = this.selectedItems.map((item) => item['uuid'])
        console.log(remittance_ids)
        let res = await this.remittance_repo.delete(remittance_ids)
        if (res['status'] == 'ok') {
            this.success_message("Remesas eliminadas correctamente")
            await this.updateRemittanceList(this.company_id, {})
        }
        else {
            this.error_message(res['error_msg'])
        }
        this.loadingDelete = false
    }
}